module.exports = __webpack_public_path__ + "img/s1-3.024d0d1c.jpg";